import { FormattedData } from './financialsModel';

import './Summary.css'
import SummaryBreakout from './SummaryBreakout';

export type Props = {
  data: FormattedData['summary']
  displayLaborHours?: boolean
}
export default function Summary({ data, displayLaborHours }: Props) {
  return (
    <div className="financial-summary">
      <SummaryBreakout title="Estimated Cost" amounts={data.estimated} type="estimated" />
      <SummaryBreakout title="Actual Cost" amounts={data.actual} type="actual" />
      <SummaryBreakout title="Unbillable Work" amounts={data.unbillable} type="unbillable" />
      {displayLaborHours && <SummaryBreakout title="Labor Hours" amounts={data.laborHours ?? []} type="laborHours" />}
    </div>
  );
}
